// src/modules/tenant-improvements/constants/api-config.js

const URLS = {
  LOCAL: 'http://localhost:3000',
  DEV: 'https://tenant-improvement-services.entratadev.green',
  PRODUCTION: 'https://tenant-improvement-services.entrata.com',
}

const LOCAL_DEV_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1'])

// Anchored suffix matchers: only the exact apex domain or a true subdomain
// of it is accepted. This blocks spoof hostnames like `entrata.com.attacker.tld`
// or `fakeentratadev.green` from being classified as first-party.
const PROD_HOSTNAME_RE = /(^|\.)entrata\.com$/i
const DEV_HOSTNAME_RE = /(^|\.)entratadev\.green$/i

const isSafeHttpUrl = (value) => {
  if (typeof value !== 'string') return false
  try {
    const parsed = new URL(value)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:'
  } catch {
    return false
  }
}

export const getBaseUrl = () => {
  const hostname =
    (typeof window !== 'undefined' && window.location?.hostname) || ''

  if (
    process.env.NODE_ENV !== 'production' &&
    LOCAL_DEV_HOSTNAMES.has(hostname) &&
    typeof window !== 'undefined' &&
    isSafeHttpUrl(window.__TI_API_URL__)
  ) {
    return window.__TI_API_URL__
  }

  if (process.env.NODE_ENV !== 'production') {
    return URLS.LOCAL
  }

  if (DEV_HOSTNAME_RE.test(hostname)) {
    return URLS.DEV
  }

  if (PROD_HOSTNAME_RE.test(hostname)) {
    return URLS.PRODUCTION
  }

  return URLS.DEV
}
